var map = {
	"./Hyphen.png": 6578,
	"./Hyu.png": 68737,
	"./Lifespan.png": 87710,
	"./Renee.png": 50712,
	"./Snitch.png": 39841,
	"./Swiss Beauty.png": 28384,
	"./WeRize.png": 98594,
	"./adidas.png": 58800,
	"./amazon.png": 74948,
	"./beato.png": 14853,
	"./bella-vita.png": 61488,
	"./boat.png": 24708,
	"./boldcare.png": 5767,
	"./bombay-shaving-company.png": 65922,
	"./booking-com.png": 75344,
	"./cadbury.png": 25081,
	"./clove-oral-care.png": 45437,
	"./croma.png": 32102,
	"./dot-and-key.png": 92786,
	"./fab-india.png": 17775,
	"./firstcry.png": 99510,
	"./fitspire.png": 21888,
	"./flipkart.png": 27858,
	"./forest-essentials-india.png": 61382,
	"./foxtale.png": 93174,
	"./giva.png": 45009,
	"./go-noise.png": 61954,
	"./kama-ayurveda.png": 52572,
	"./kama.png": 58913,
	"./kindlife.png": 71122,
	"./koparo-clean.png": 83435,
	"./libas.png": 79514,
	"./mamaearth.png": 5348,
	"./max-protein.png": 73866,
	"./mcaffeine.png": 32556,
	"./medibuddy.png": 80299,
	"./minimalist.png": 10912,
	"./muscleblaze.png": 78392,
	"./neeman.png": 13557,
	"./nykaa.png": 33310,
	"./plum-goodness.png": 72721,
	"./puer.png": 98999,
	"./puma.png": 1026,
	"./shopsy.png": 54775,
	"./shyaway.png": 49735,
	"./smytten.png": 45958,
	"./sova-health.png": 36263,
	"./ssbeauty.png": 96820,
	"./the-derma-co.png": 91949,
	"./the-man-company.png": 26136,
	"./times-prime.png": 90301,
	"./truemeds.png": 25768,
	"./weryze.png": 4661,
	"./world-of-asaya.png": 33423,
	"./wow.png": 53869,
	"./xyxx-crew.png": 80271,
	"./zandu-care.png": 54271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73925;